import { render, staticRenderFns } from "./OpenmarketQR.vue?vue&type=template&id=2c675c8b&scoped=true"
import script from "./OpenmarketQR.vue?vue&type=script&lang=js"
export * from "./OpenmarketQR.vue?vue&type=script&lang=js"
import style0 from "./OpenmarketQR.vue?vue&type=style&index=0&id=2c675c8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c675c8b",
  null
  
)

export default component.exports